import React, { useContext } from 'react';
import { Icon } from 'uxd-design-system-components';
import { LocaleContext } from '../../contexts';
import getText from '../../assets/locale/locale';

const ShareLinkIcon = () => {
  const locId = useContext(LocaleContext);
  function openEmailForUser() {
    window.open(getText(locId, 'Results', 'defaultEmailText', 'shareQuizCta'));
  }

  return (
    <>
      <div
        className="shareLink_icon"
        role="button"
        data-testid="shareLink_icon"
        onClick={() => {
          openEmailForUser();
        }}
        onKeyDown={(event) => {
          if (event.keyCode === 13 || event.keyCode === 32) {
            openEmailForUser();
          }
        }}
        tabIndex="0"
      >
        <Icon name="message-envelope" />
      </div>
    </>
  );
};

export default ShareLinkIcon;
